<template>
  <div>
    <BaseTitle :title="$t('content.assignment_title')" :yearPeriode="titleData" />
    <v-card class="mb-5" v-for="grup in grupList" v-bind:key="grup.assignmentGroupId">
      <slide-box :value="true">
        <template #activator="{isOpen}">
          <div class="pa-5 d-flex justiy-space-between align-items section-header active">
            <div class="student-title">{{ grup.assignmentGroupName }}</div>
            <v-spacer />
            <div class="header-circle mr-10" v-if="grup.assignmentGroupName != 'Ungroup' && grup.groupPercentage > 0">
              <span class="header-circle-text">{{ grup.groupPercentage }}% {{ $t('content.of_total') }} </span>
            </div>
            <v-icon class="app-menu-indicator">{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
          </div>
        </template>
        <template>
          <div class="assignment-content ml-10">
            <!-- <v-data-table
              :headers="tableHeader"
              :items="grup.assignments"
              :loading="table.loading"
              disable-pagination
              hide-default-footer
              class="table-custom"
            >
              <template #item.assignmentTitle="{ item }">
                <span> <svg-icon icon="assigment-ic" class="mr-5" /> {{ item.assignmentTitle }} </span>
              </template>
              <template #item.submitted="{ item }">
                <ol style="list-style-type: inherit; color:#CE8800" v-if="item.submitted === false">
                  <li>
                    <strong style="color: #CE8800;">{{ $t('content.no_submission') }}</strong>
                    <strong v-if="item.submitted === true" style="color: #6DD400;">{{ $t('content.submitted') }}</strong>
                  </li>
                </ol>
                <ol style="list-style-type: inherit; color:#6DD400" v-if="item.submitted === true">
                  <li>
                    <strong v-if="item.submitted === true" style="color: #6DD400;">{{ $t('content.submitted') }}</strong>
                  </li>
                </ol>
              </template>
              <template #item.assignmentTypeId="{ item }">
                <span v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </span>
                <span v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</span>
                <span v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</span>
                <span v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</span>
              </template>
              <template #item.point="{ item }">
                <span v-if="(item.point === 0 && item.published === false) || item.excused"> - / {{ item.totalPoint }} Pts</span>
                <span v-else> {{ item.point }} / {{ item.totalPoint }} Pts</span>
              </template>
              <template #item.availableFromDate="{ item }">
                <span v-if="!item.availableFromDate">-</span>
                <span v-else>{{ item.availableFromDate }}</span>
              </template>
              <template #item.dueDate="{ item }">
                <span v-if="!item.dueDate">-</span>
                <span v-else>{{ item.dueDate }}</span>
              </template>
              <template #item.actions="{ item }">
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="showDetail(item)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
              <template #no-data>
                <NoData />
              </template>
            </v-data-table> -->
            <div v-for="item in grup.assignments" :key="item.assignmentId" :item="item">
              <v-row class="border-item">
                <!-- <v-col md="1" align="center">
                  <div class="pa-5">
                    <svg-icon icon="assigment-ic" class="primary--text assigment-icon" />
                  </div>
                </v-col> -->
                <v-col md="8" class="mt-5">
                  <div class="d-block mb-2">
                    <h3 class="d-inline">
                      {{ item.assignmentTitle }}
                    </h3>
                  </div>
                  <div class="d-block">
                    <div>
                      <span>
                        <span class="mr-3">
                          {{ $t('form.datatype') }}:
                          <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                          <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                          <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                          <strong style="color:#00BF63;" v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('form.status') }}:
                          <strong v-if="item.submitted === false" style="color: #CE8800;">{{ $t('content.no_submission') }}</strong>
                          <strong v-if="item.submitted === true" style="color: #6DD400;">{{ $t('content.submitted') }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('content.available_from') }}:
                          <span v-if="!item.availableFromDate">-</span>
                          <span v-else>{{ item.availableFromDate }}</span>
                        </span>
                        |

                        <span class="ml-3 mr-3"
                          >{{ $t('content.due_date') }} :
                          <strong style="color:#E02020;">{{ item.dueDate }}</strong>
                          <strong style="color:#E02020;" v-if="item.dueDate === null">-</strong>
                        </span>
                        |
                        <span class="ml-3 mr-3">
                          <span>{{ $t('menu.score') }} : </span>
                          <span style="color:#00bf63;" v-if="(item.point === 0 && item.published === false) || item.excused"
                            >0 / {{ item.totalPoint }} Pts</span
                          >
                          <span style="color:#00bf63;" v-else> {{ item.point }} / {{ item.totalPoint }} Pts</span>
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="d-flex"></div>
                </v-col>
                <v-col md="3" class="mt-8">
                  <v-row class="mb-6" no-gutters>
                    <v-col md="12">
                      <v-progress-linear
                        :color="item.color ? 'red darken-2' : '#CE8800'"
                        height="14"
                        background-color="#E3E3E3"
                        :value="item.percen"
                        style="border-radius: 9px;"
                      >
                      </v-progress-linear>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col md="12" class="d-flex justify-space-between">
                      <span v-if="item.availableFromDate">{{ item.availableFromDate }} </span>
                      <span v-if="!item.availableFromDate">-</span>
                      <span v-if="item.dueDate" style="color:#E02020;">{{ item.dueDate }} </span>
                      <span v-if="!item.dueDate" style="color:#E02020;">- </span>
                    </v-col>
                  </v-row>
                  <!-- <div class="d-flex justify-space-between mt-12" :color="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'" flat tile>
                    <span class="mr-2 mt-1">{{ item.availableFromDate }} </span>
                    <v-progress-linear height="14" :value="20" style="border-radius: 9px;"> </v-progress-linear>
                    <span class="ml-2 mt-1">{{ item.dueDate }} </span>
                  </div> -->
                </v-col>
                <v-col md="1">
                  <template>
                    <div class="pa-5">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <span dark v-bind="attrs" v-on="on">
                            <svg-icon icon="ic-moreaction-black" class="mt-1" />
                          </span>
                        </template>
                        <v-list>
                          <v-list-item>
                            <v-list-item-title class="text-dropdown" @click="showDetail(item)">{{ $t('view') }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-col>
              </v-row>
              <!-- <div class="assignment-item">
                <div class="assignment-item-icon">
                  <svg-icon icon="assigment-ic" />
                </div>
                <div class="assignment-item-section">
                  <strong>{{ item.assignmentTitle }}</strong>
                </div>
                <div class="assignment-item-section">
                  <span class="d-block">{{ $t('content.assignment_type') }}</span>
                  <strong v-if="item.assignmentTypeId == 4">{{ $t('content.assignment_item.manual_input') }} </strong>
                  <strong v-if="item.assignmentTypeId == 3">{{ $t('content.assignment_item.attendance') }}</strong>
                  <strong v-if="item.assignmentTypeId == 2">{{ $t('content.assignment_item.quiz') }}</strong>
                  <strong v-if="item.assignmentTypeId == 1">{{ $t('content.assignment_item.upload_files') }}</strong>
                </div>
                <div class="assignment-item-section ml-4">
                  <span class="assignment-item-section-title">{{ $t('content.available_from') }}</span>
                  <strong style="color:#00BF63;">{{ item.availableFromDate }}</strong>
                  <strong style="color:#00BF63;" v-if="item.availableFromDate === null">-</strong>
                </div>
                <div class="assignment-item-section">
                  <span class="assignment-item-section-title">{{ $t('content.due_date') }}</span>
                  <strong style="color:#FA6400;">{{ item.dueDate }}</strong>
                  <strong style="color:#FA6400;" v-if="item.dueDate === null">-</strong>
                </div>
                <div class="assignment-item-section">
                  <span class="assignment-item-section-title">{{ $t('menu.score') }}</span>
                  <strong v-if="(item.point === 0 && item.published === false) || item.excused"> - / {{ item.totalPoint }} Pts</strong>
                  <strong v-else> {{ item.point }} / {{ item.totalPoint }} Pts</strong>
                </div>

                <div class="assignment-item-section">
                  <v-btn color="primary" class="btn-primary-custom " @click="showDetail(item)">{{ $t('view') }}</v-btn>
                </div>
              </div> -->
            </div>

            <NoData v-if="!grup.assignments.length" />
          </div>
        </template>

        <template>
          <v-card class="pa-5 d-flex justify-space-between section-footer">
            <strong class="ml-12">Total</strong>
            <strong class="mr-12">
              <strong v-if="grup.percentage === 0">-</strong>
              <strong v-else>{{ Math.round(grup.percentage) }}% </strong>
              <strong class="ml-12" v-if="grup.point === 0 && grup.totalPoint === 0">0</strong>
              <strong class="ml-12" v-else>{{ grup.point }}/{{ grup.totalPoint }}</strong>
            </strong>
          </v-card>
        </template>
      </slide-box>
    </v-card>

    <div class="succ" v-if="!grupList.length">
      <div class="succ-content">
        <v-progress-circular class="text-center" v-if="loadingButton === true" indeterminate color="primary"></v-progress-circular>
        <svg-icon icon="ic-nodata-mini" class="succ-featured" width="130" height="100" />
        <h1 class="succ-heading">{{ $t('nodata_title') }}</h1>
        <div class="succ-content mb-8">{{ $t('nodata_body') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import SlideBox from '@/components/SlideBox';
import NoData from '@/components/table/NoData';
import moment from 'moment-timezone';

export default {
  name: 'AssignmentIndex',
  components: {
    BaseTitle,
    SlideBox,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'Assignment/items',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    }),
    tableHeader() {
      return [
        { text: 'Name', value: 'assignmentTitle' },
        { text: this.$t('content.assignment_type'), value: 'assignmentTypeId' },
        { text: this.$t('form.status'), value: 'submitted' },
        { text: this.$t('content.available_from'), value: 'availableFromDate' },
        { text: this.$t('content.due_date'), value: 'dueDate' },
        { text: this.$t('menu.score'), value: 'point' },
        { text: this.$t('table.action'), value: 'actions', sortable: false, width: 180 }
      ];
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    updateAssignment({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: this.$t('alert.list_assignment') });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  data: () => ({
    grupList: [],
    dataClass: '',
    gmt: '',
    loadingButton: false,
    table: {
      loading: false,
      options: {}
    },
    titleData: ''
  }),
  methods: {
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        if (res.gmt === null) {
          this.gmt = 'Asia/Jakarta';
        } else {
          this.gmt = res.gmt;
        }
      });
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      const { classId, courseId } = this.$route.params;
      this.loadingButton = true;
      this.$store
        .dispatch('Assignment/fetchListStudent', {
          classId,
          courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : ''
        })
        .then(res => {
          res.forEach(form => {
            form.assignments.forEach(datas => {
              if (datas.availableFromValid) {
                var tgl = moment(datas.availableFromValid).format('YYYY/MM/DD');
                var tgl1 = moment(datas.dueDate, 'DD-MM-YYYY HH:mm').format('YYYY/MM/DD');
                var current = moment().format('YYYY/MM/DD');

                var gap = moment(tgl1, 'YYYY-MM-DD')
                  .startOf('day')
                  .diff(moment(tgl, 'YYYY-MM-DD').startOf('day'), 'days');
                var currentResult = moment(tgl1, 'YYYY-MM-DD')
                  .startOf('day')
                  .diff(moment(current, 'YYYY-MM-DD').startOf('day'), 'days');
                var result = Math.round((currentResult / gap) * 100);
                var resultGraphic = 100 - result;
                datas.percen = resultGraphic;
                if (resultGraphic > 50) {
                  datas.color = true;
                } else {
                  datas.color = false;
                }
              } else {
                datas.percen = 0;
                datas.stat = false;
              }
            });
          });
          this.grupList = res;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    },
    showDetail({ assignmentId, availableFromValid }) {
      if (availableFromValid) {
        var future = availableFromValid;
        if (this.gmt) {
          var convertAwal = moment()
            .tz(this.gmt)
            .format('YYYY-MM-DD HH:mm');
        } else {
          convertAwal = moment().format('YYYY-MM-DD HH:mm');
        }
        var convertAkhir = moment(future).format('YYYY-MM-DD HH:mm');
        if (convertAwal >= convertAkhir) {
          localStorage.setItem('detailStudent', true);
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'StudentAssignmentDetail', params: { assignmentId } });
          } else {
            this.$router.push({ name: 'StudentSectionAssignmentDetail', params: { assignmentId } });
          }
        } else {
          this.$store.dispatch('general/showErrorNotification', { message: this.$t('alert.available_from') });
          localStorage.setItem('detailStudent', false);
        }
      } else {
        localStorage.setItem('detailStudent', true);
        if (!this.$route.params.classSectionId) {
          this.$router.push({ name: 'StudentAssignmentDetail', params: { assignmentId } });
        } else {
          this.$router.push({ name: 'StudentSectionAssignmentDetail', params: { assignmentId } });
        }
      }
    }
  },
  created() {
    localStorage.removeItem('detailStudent');
    this.getDataClass();
    this.getData();
    this.getProfile();
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.header-circle {
  background-color: #00bf63;
  border: 1px solid #ffffff;
  border-radius: 8px;
  width: 96px;
  height: 23px;
}
.header-circle-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  margin-left: 10px;
}
.assignment-item {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #acacac;
  &:last-child {
    border-bottom: 0;
  }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 40px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    font-size: 12px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;
  }
}
.border-item {
  border-bottom: 1px solid #dedede;
}

.assigment-icon {
  width: 40px;
  height: 40px;
}
</style>
